exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.footer-image {\r\n    width: 150px;\r\n    display: inline-block;\r\n    margin: 10px 50px;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .login-bg {\r\n        position: fixed;\r\n        top: 0px;\r\n        bottom: 0px;\r\n        right: 0px;\r\n        left: 50%;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/security/login/login.component.css
// module id = 992
// module chunks = 1